/**
 * No-operation function. Use as a default for optional callbacks or for
 * required handler props whose behaviour is intentionally empty.
 */
export const noop = () => {};
